import React from 'react';

// project import
import { MainCard } from 'components';
import { connect } from 'react-redux';
import RentalCheckTimesForm from '../../components/Rental/RentalCheckTimesForm';

// ==============================|| TAB - MODULES & ROLES ||============================== //

const TabRentalManagement = ({
    selectedOrg,
    orgProperties,
    setTableIndex,
    setRowCount
}) => {
    return (
        <MainCard title="Rental management">
            {selectedOrg && (
                <>
                    <RentalCheckTimesForm selectedOrg={selectedOrg} />
                </>
            )}
        </MainCard>
    );
};

const mapStateToProps = ({ org, properties }) => {
    const { selectedOrg } = org;
    const { orgProperties } = properties;
    return { orgProperties, selectedOrg };
};

export default connect(mapStateToProps, {})(TabRentalManagement);
